import React from 'react'
import { FormattedMessage } from 'react-intl'
import Signin from '../../containers/Signin'

export const SigninOverlay = () => {
  return (
    <div className='Signin__body'>
      <span className='Signin__undertitle Text'><FormattedMessage id='bid.login_required' /></span>
      <Signin noBody />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Lot/SigninOverlay.jsx